import { WidgetSchema, WidgetSchemaAccount } from '@/entities/widget';

export const isWidgetSchemaAccount = (
  widget?: WidgetSchema,
): widget is WidgetSchemaAccount => {
  return !!widget && !!(widget as WidgetSchemaAccount).background;
};
